import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortConfiguration } from '../components/generics/data-table/data-table.component';
import { Zona } from '../models/zona.model';
import { UtilsService } from './utils.service';

@Injectable({
    providedIn: 'root'
})
export class ZonasService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService
    ) { }

    getZonas(page: number, itemsPerPage: number, sorts: SortConfiguration[], extraParams: any) {
        const url = '/calculadora/zonas';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts)
        };
        Object.assign(params, JSON.parse(JSON.stringify(extraParams)));
        return this.http.get<Zona[]>(url, { headers, observe: 'response', params });
    }

    getZonaById(id: number) {
        return this.http.get<Zona>(`/calculadora/zonas/${id}`);
    }

    createZona(zona: Zona) {
        return this.http.post<Zona>('/calculadora/zonas', zona);
    }

    updateZona(zona: Zona) {
        return this.http.put<Zona>(`/calculadora/zonas/${zona.id}`, zona);
    }

    deleteZona(id: number) {
        return this.http.delete<Zona>(`/calculadora/zonas/${id}`);
    }
}
